import { memo } from 'react';
import styles from './index.less';
import defaultUrl from '@/assets/user/defaultImage.png';
import goldUrl from '@/assets/user/gold.png';
import { history, useModel } from '@umijs/max';
import { Tag } from 'react-vant';

function Title({
  token,
  name,
  userType,
}: {
  token: string;
  name: any;
  userType?: string;
}) {
  const toLogin = () => {
    history.push('/login');
  };
  if (token) {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <p
          style={{
            fontSize: 16,
            color: '#1d2129',
            fontWeight: 'bold',
            marginBottom: 4,
            marginRight: 4,
          }}
        >
          {name}
        </p>
        <Tag>{userType}</Tag>
      </div>
    );
  }
  return <p onClick={toLogin}>未登录</p>;
}
const UserInfo = () => {
  const token = localStorage.getItem('token');
  const { userInfo } = useModel('useGlobal', (model) => ({
    userInfo: model.userInfo,
  }));
  const { ownerInformation } = useModel('useDefaultRoom', (model) => ({
    ownerInformation: model.ownerInformation,
  }));

  const { totalAmount } = useModel('useAccount', (model) => ({
    totalAmount: model.totalAmount,
  }));

  const goToAccountInfo = () => {
    history.push('/accountInformation');
  };

  const goToAccountBill = () => {
    history.push('/account/bill');
  };

  return (
    <div className={styles.content}>
      <div className={styles['user-info']}>
        <img src={userInfo?.headimgurl || defaultUrl} alt={'user'} />
        <div>
          <Title
            token={token!}
            name={ownerInformation?.nickName}
            userType={ownerInformation?.userType}
          />
          <span>{ownerInformation?.phonenumber}</span>
        </div>
      </div>
      <div className={styles['user-account']}>
        <div className={styles['account-info']}>
          <img src={goldUrl} alt={'gold'} />
          <p>账户余额￥</p>
        </div>
        <div className={styles['account-amount']}>
          <p onClick={goToAccountBill}>{totalAmount}</p>
          <span onClick={goToAccountInfo}>账户明细</span>
        </div>
      </div>
    </div>
  );
};
export default memo(UserInfo);
